// extracted by mini-css-extract-plugin
module.exports = {"container":"SatisfactionGuarantee_container__0gyQC","variant-dark":"SatisfactionGuarantee_variant-dark__82w_X"};